import React from 'react';
import PersonalDashboard from './personal/PersonalDashboard';

/** Home for users without an admin/manager board; see personal/PersonalDashboard. */
const UserDashboardView: React.FC = () => <PersonalDashboard />;

export default UserDashboardView;
